import * as React from "react";

import { skipToken } from "@tanstack/react-query";
import { useCurrentWorkspaceId } from "@v2/contexts/WorkspaceDashboardContext";
import { agentBillingRouter } from "@v2/trpc/routes/agentBilling";

import { ALWAYS_FRESH, ReadOnlyJsonEditor } from "./shared";

export const RawSubscriptionJson: React.FC = () => {
  const workspaceId = useCurrentWorkspaceId();
  const { data: subscription } = agentBillingRouter.subscription.find.useQuery(
    workspaceId ? { workspaceId } : skipToken,
    ALWAYS_FRESH,
  );

  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-muted text-xs">
        Response from subscription.find tRPC query (includes Stripe subscription
        ID, items, billing interval, period dates, etc.)
      </span>
      {subscription ? (
        <ReadOnlyJsonEditor value={subscription} />
      ) : (
        <div className="text-muted text-xs">No subscription</div>
      )}
    </div>
  );
};
